"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "gardone-val-trompia": {
    "acb7c8ef": [{
      "hkey": "281b338e",
      "slug": "centro",
      "name": "Centro",
      "primary": true,
      "skipSearch": false
    }],
    "centro-inzino": [{
      "hkey": "281b338e",
      "slug": "centro",
      "name": "Centro",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "34acc9bc": [{
      "hkey": "7a414073",
      "slug": "gardone-val-trompia",
      "name": "Gardone Val Trompia",
      "primary": true,
      "skipSearch": false
    }],
    "bersaglio": [{
      "hkey": "7a414073",
      "slug": "gardone-val-trompia",
      "name": "Gardone Val Trompia",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "d0f3c6fa": [{
      "hkey": "281b338e",
      "slug": "centro",
      "name": "Centro",
      "primary": true,
      "skipSearch": false
    }],
    "inzino": [{
      "hkey": "281b338e",
      "slug": "centro",
      "name": "Centro",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "477d9876": [{
      "hkey": "7a414073",
      "slug": "gardone-val-trompia",
      "name": "Gardone Val Trompia",
      "primary": true,
      "skipSearch": false
    }],
    "oneto": [{
      "hkey": "7a414073",
      "slug": "gardone-val-trompia",
      "name": "Gardone Val Trompia",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "4417e48b": [{
      "hkey": "7a414073",
      "slug": "gardone-val-trompia",
      "name": "Gardone Val Trompia",
      "primary": true,
      "skipSearch": false
    }],
    "paule-sopra": [{
      "hkey": "7a414073",
      "slug": "gardone-val-trompia",
      "name": "Gardone Val Trompia",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "71a14413": [{
      "hkey": "7a414073",
      "slug": "gardone-val-trompia",
      "name": "Gardone Val Trompia",
      "primary": true,
      "skipSearch": false
    }],
    "paule-sotto": [{
      "hkey": "7a414073",
      "slug": "gardone-val-trompia",
      "name": "Gardone Val Trompia",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "80c737e0": [{
      "hkey": "7a414073",
      "slug": "gardone-val-trompia",
      "name": "Gardone Val Trompia",
      "primary": true,
      "skipSearch": false
    }],
    "piaine": [{
      "hkey": "7a414073",
      "slug": "gardone-val-trompia",
      "name": "Gardone Val Trompia",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "1311a681": [{
      "hkey": "7a414073",
      "slug": "gardone-val-trompia",
      "name": "Gardone Val Trompia",
      "primary": true,
      "skipSearch": false
    }],
    "piazza-cannoni": [{
      "hkey": "7a414073",
      "slug": "gardone-val-trompia",
      "name": "Gardone Val Trompia",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "e3900590": [{
      "hkey": "7a414073",
      "slug": "gardone-val-trompia",
      "name": "Gardone Val Trompia",
      "primary": true,
      "skipSearch": false
    }],
    "pole": [{
      "hkey": "7a414073",
      "slug": "gardone-val-trompia",
      "name": "Gardone Val Trompia",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "39c97014": [{
      "hkey": "7a414073",
      "slug": "gardone-val-trompia",
      "name": "Gardone Val Trompia",
      "primary": true,
      "skipSearch": false
    }],
    "quadro": [{
      "hkey": "7a414073",
      "slug": "gardone-val-trompia",
      "name": "Gardone Val Trompia",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "c68dbb02": [{
      "hkey": "7a414073",
      "slug": "gardone-val-trompia",
      "name": "Gardone Val Trompia",
      "primary": true,
      "skipSearch": false
    }],
    "rodoleto": [{
      "hkey": "7a414073",
      "slug": "gardone-val-trompia",
      "name": "Gardone Val Trompia",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "9df7afa3": [{
      "hkey": "7a414073",
      "slug": "gardone-val-trompia",
      "name": "Gardone Val Trompia",
      "primary": true,
      "skipSearch": false
    }],
    "romagnoli": [{
      "hkey": "7a414073",
      "slug": "gardone-val-trompia",
      "name": "Gardone Val Trompia",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "1e79ddef": [{
      "hkey": "7a414073",
      "slug": "gardone-val-trompia",
      "name": "Gardone Val Trompia",
      "primary": true,
      "skipSearch": false
    }],
    "san-bartolomeo": [{
      "hkey": "7a414073",
      "slug": "gardone-val-trompia",
      "name": "Gardone Val Trompia",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "5f766c67": [{
      "hkey": "7a414073",
      "slug": "gardone-val-trompia",
      "name": "Gardone Val Trompia",
      "primary": true,
      "skipSearch": false
    }],
    "san-luigi": [{
      "hkey": "7a414073",
      "slug": "gardone-val-trompia",
      "name": "Gardone Val Trompia",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "249dc3a2": [{
      "hkey": "7a414073",
      "slug": "gardone-val-trompia",
      "name": "Gardone Val Trompia",
      "primary": true,
      "skipSearch": false
    }],
    "san-rocco": [{
      "hkey": "7a414073",
      "slug": "gardone-val-trompia",
      "name": "Gardone Val Trompia",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;